import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { apolloClient } from './lib/apollo'
import { nightlyReload } from './lib/nightlyReload'
import './index.css'

// The page runs for weeks on a TV that is never touched: arm the nightly reload once
// at boot (build-guide §7).
nightlyReload()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>,
)
